export const appLocation = window.location
export const appOriginUrl = appLocation.origin
export const appUrl = appOriginUrl
